var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 200,
    viewBox: "0 0 251 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.5 64a7 7 0 110 14h64a7 7 0 110 14h22a7 7 0 110 14h-19a7 7 0 100 14h6a7 7 0 110 14h-146a7 7 0 110-14h-39a7 7 0 110-14h40a7 7 0 100-14h-25a7 7 0 110-14h40a7 7 0 110-14h57zm90 56a7 7 0 110 14 7 7 0 010-14z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5 140c-12.15 0-22-9.626-22-21.5S80.35 97 92.5 97c.517 0 1.03.017 1.537.052A34.205 34.205 0 0193.5 91c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31.347 31.347 0 01163 80c16.845 0 30.5 13.431 30.5 30 0 15.741-12.325 28.727-28 29.978V140h-73zm11.996 0h-6.965 6.965z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.496 140h-6.965m-5.031 0c-12.15 0-22-9.626-22-21.5S80.35 97 92.5 97c.517 0 1.03.017 1.537.052A34.205 34.205 0 0193.5 91c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31.347 31.347 0 01163 80c16.845 0 30.5 13.431 30.5 30 0 15.741-12.325 28.727-28 29.978V140h-73z",
    stroke: "#F04438",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 126a5.5 5.5 0 100-11 5.5 5.5 0 100 11z",
    stroke: "#F04438",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 109l7-5.493-7-5.23",
    stroke: "#F04438",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 109l-7-5.493 7-5.23",
    stroke: "#F04438",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 67a19.035 19.035 0 0113.44 13.293",
    stroke: "#FDA29B",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 50a3 3 0 100-6 3 3 0 000 6z",
    stroke: "#FDA29B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 66a3 3 0 100-6 3 3 0 000 6z",
    fill: "#FDA29B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.257 57.757l8.359 8.359m.127-8.359l-8.359 8.359 8.359-8.359z",
    stroke: "#FDA29B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.904 75.596l6 6m0-6l-6 6 6-6z",
    stroke: "#FDA29B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 69a3 3 0 100-6 3 3 0 000 6z",
    fill: "#FDA29B"
  })));
}

export default SvgError;